import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img src="/qnc-logo.png" alt="QNC Company Ltd" className="h-12 w-auto" />
            </div>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              {companyInfo.tagline}
            </p>
            <p className="text-gray-400 text-sm">
              Your trusted partner for construction, prefab buildings, generators, and quality tools in Jamaica.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('generator-tool')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  Power Generator
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('projects')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  Projects
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-200 text-sm"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('construction-services')}
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200"
                >
                  Construction Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('prefab-steel-buildings')}
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200"
                >
                  Prefab Steel Buildings
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('generator-solutions')}
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200"
                >
                  Generator Solutions
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('tools-and-equipment')}
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200"
                >
                  Tools & Equipment
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="w-5 h-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-400">{companyInfo.address}</span>
              </li>
              <li className="flex items-center">
                <Phone className="w-5 h-5 text-blue-400 mr-2 flex-shrink-0" />
                <span className="text-sm text-gray-400">{companyInfo.phone}</span>
              </li>
              <li className="flex items-center">
                <Mail className="w-5 h-5 text-blue-400 mr-2 flex-shrink-0" />
                <span className="text-sm text-gray-400">{companyInfo.email}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Sales Rep CTA */}
        <div className="border-t border-gray-800 pt-8 pb-8">
          <div className="bg-gradient-to-r from-blue-600 to-blue-800 rounded-lg p-6 text-center">
            <h3 className="text-xl font-bold text-white mb-2">
              Join Our Sales Team
            </h3>
            <p className="text-blue-100 mb-4">
              Earn up to USD $500 per confirmed generator sale + car upkeep support
            </p>
            <Link to="/sales-rep">
              <button className="bg-white text-blue-600 px-6 py-2 rounded-lg font-semibold hover:bg-blue-50 transition-colors duration-200">
                Apply Now
              </button>
            </Link>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400 mb-4 md:mb-0">
              © {currentYear} QNC Co. Limited. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Privacy Policy
              </Link>
              <Link to="/terms-of-use" className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Terms of Use
              </Link>
              <Link to="/sales-rep" className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Become a Sales Rep
              </Link>
              <Link to="/login" className="text-sm text-gray-400 hover:text-blue-400 transition-colors duration-200">
                Portal Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;